import { render } from "./unauthorized-page.vue?vue&type=template&id=25f54cb1&ts=true"
import script from "./unauthorized-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./unauthorized-page.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/auth/unauthorized-page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25f54cb1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25f54cb1', __exports__)) {
    api.reload('25f54cb1', __exports__)
  }
  
  module.hot.accept("./unauthorized-page.vue?vue&type=template&id=25f54cb1&ts=true", () => {
    api.rerender('25f54cb1', render)
  })

}


export default __exports__